"use strict";

var isEqual = require('lodash/isEqual');
/**
 * Checks if a price table is properly formatted.
 *
 * Checks a price table only has v{version} as its first level keys.
 * Checks a price table is not empty {}.
 *
 * @memberof! Pricing
 * @param {object} table Price table data.
 * @return {boolean} True if price table is proper format, false if not.
 * @throws {Error} When name is the empty string.
 * @throws {Error} When name is null or undefined.
 */


function isProperFormat(table) {
  // Validate inputs.
  if (table == null) {
    debugger;
    throw new Error('Input cannot be null or undefined.');
  }

  if (isEqual(table, {})) {
    return false;
  }

  var keys = Object.keys(table); // Detect if all first level keys match the format v{number}.

  var regex = /^v\d+$/;
  var proper = true;
  keys.forEach(function (key) {
    if (!key.match(regex)) {
      proper = false;
    }
  });

  if (!proper) {
    return proper;
  } // Strip out numbers from keys and sort the numeric array.


  regex = /\d+/;
  var match;
  keys = keys.map(function (value) {
    match = value.match(regex);
    return match ? parseInt(match[0], 10) : value;
  });
  keys.sort(function (a, b) {
    return a - b;
  }); // Detect if keys increment by 1 and start at 0.

  var last_version = -1;
  var version;

  for (var i = 0; i < keys.length; i++) {
    version = keys[i];

    if (version !== last_version + 1) {
      proper = false;
    }

    last_version = version;
  }

  return proper;
}

module.exports = isProperFormat;